// extracted by mini-css-extract-plugin
module.exports = {"total":"Heading_total__11Z0e"};